import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const PanelLeftIcon = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx("svg", {
        ref: ref,
        ...props,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M26.87 3H5.13C4.56509 3 4.02331 3.22441 3.62386 3.62386C3.22441 4.02331 3 4.56509 3 5.13V26.87C3 27.4349 3.22441 27.9767 3.62386 28.3761C4.02331 28.7756 4.56509 29 5.13 29H26.87C27.4349 29 27.9767 28.7756 28.3761 28.3761C28.7756 27.9767 29 27.4349 29 26.87V5.13C29 4.56509 28.7756 4.02331 28.3761 3.62386C27.9767 3.22441 27.4349 3 26.87 3ZM5.38 5.38H11.28V26.62H5.38V5.38ZM26.62 26.62H13.46V5.38H26.62V26.62Z"
        })
    }));
PanelLeftIcon.displayName = "PanelLeftIcon";
